import React from 'react';
import Welcome from '../../images/welcome.png';

const WelcomeBg = props => <img src={Welcome} {...props} alt="Welcome" />;
export default WelcomeBg;
